
// import React from 'react';
// import PropTypes from 'prop-types';
// import { withStyles } from '@material-ui/core/styles';
// import Button from '@material-ui/core/Button';
// import Avatar from '@material-ui/core/Avatar';
// import List from '@material-ui/core/List';
// import ListItem from '@material-ui/core/ListItem';
// import ListItemAvatar from '@material-ui/core/ListItemAvatar';
// import ListItemText from '@material-ui/core/ListItemText';
// import DialogTitle from '@material-ui/core/DialogTitle';
// import Dialog from '@material-ui/core/Dialog';
// import PersonIcon from '@material-ui/icons/Person';
// import AddIcon from '@material-ui/icons/Add';
// import Typography from '@material-ui/core/Typography';
// import blue from '@material-ui/core/colors/blue';
// import ShareIcon from '@material-ui/icons/Share';
// import { FacebookShareButton, LinkedinShareButton, TwitterShareButton} from 'react-share';
// import IconButton from '@material-ui/core/IconButton';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import CloseIcon from '@material-ui/icons/Close';
// import Fab from '@material-ui/core/Fab';

// const styles = {
//   avatar: {
//     backgroundColor: blue[100],
//     color: blue[600],
//   },
// };

// class ShareDialog extends React.Component {
//   handleClose = () => {
//     this.props.onClose(this.props.selectedValue);
//   };

//   handleListItemClick = value => {
//     this.props.onClose(value);
//   };

//   render() {
//     const { classes, onClose, selectedValue, ...other } = this.props;

//     return (
//       <Dialog onClose={this.handleClose} aria-labelledby="dialog-title" {...other}>
//       <div style={{display: 'flex'}}>
//         <IconButton color="inherit" style={{paddingLeft: 22}} onClick={this.handleClose} aria-label="Close">
//             <CloseIcon />
//         </IconButton>
//         <DialogTitle id="dialog-title" style={{padding: '24px 8px 20px'}}>Share With</DialogTitle>
//       </div>
      
//         <div>
//           <List>
//             <ListItem button onClick={() => this.handleListItemClick('facebookShare')}>
//               <ListItemAvatar>
//               <FacebookShareButton
//                 // url={`${process.env.BACKEND_URL}${url.asPath}`}
//                 // quote={item.title}
//               >                
//                 <IconButton aria-label="Share" style={{color: '#fff'}}>
//                     <FontAwesomeIcon icon={['fab', 'facebook-f']} style={{color: '#014ca9'}} />
//                 </IconButton>
                  
//               </FacebookShareButton>
//               </ListItemAvatar>
//               <ListItemText primary="Facebook" />
//             </ListItem>
//             <ListItem button onClick={() => this.handleListItemClick('twitterShare')}>
//               <ListItemAvatar>
//                 <TwitterShareButton
//                     // url={`${process.env.BACKEND_URL}${url.asPath}`}
//                     // title={item.title}
//                 >
//                     <IconButton aria-label="Share" style={{color: '#fff'}}>
//                         <FontAwesomeIcon icon={['fab', 'twitter']} style={{color: '#00aff2'}} />
//                     </IconButton>
//                 </TwitterShareButton>
//               </ListItemAvatar>
//               <ListItemText primary="Twitter" />
//             </ListItem>
//             <ListItem button onClick={() => this.handleListItemClick('linkedinShare')}>
//               <ListItemAvatar>
//               <LinkedinShareButton
//                 // url={`${process.env.BACKEND_URL}${url.asPath}`}
//                 windowWidth={750}
//                 windowHeight={600}
//               >
//                <IconButton aria-label="Share" style={{color: '#fff'}}>
//                 <FontAwesomeIcon icon={['fab', 'linkedin-in']} style={{color: '#006cc6'}} />
//                 </IconButton>
//               </LinkedinShareButton> 
//               </ListItemAvatar>
//               <ListItemText primary="Linkdin" />
//             </ListItem>
            
//           </List>
//         </div>
//       </Dialog>
//     );
//   }
// }

// ShareDialog.propTypes = {
//   classes: PropTypes.object.isRequired,
//   onClose: PropTypes.func,
//   selectedValue: PropTypes.string,
// };

// const ShareDialogWrapped = withStyles(styles)(ShareDialog);

// class VideoDetailShareBtn extends React.Component {
//   state = {
//     open: false,
//   };

//   handleClickOpen = () => {
//     this.setState({
//       open: true,
//     });
//   };

//   handleClose = value => {
//     this.setState({ selectedValue: value, open: false });
//   };

//   render() {
//     return (
//       <div>
//         <Fab color="primary" aria-label="Share" onClick={this.handleClickOpen} style={{ position: 'fixed', bottom: 85, right: 20, zIndex: 1}}>
//             <ShareIcon />
//         </Fab>
//         <ShareDialogWrapped
//           selectedValue={this.state.selectedValue}
//           open={this.state.open}
//           onClose={this.handleClose}
//         />
//       </div>
//     );
//   }
// }

// export default VideoDetailShareBtn;


import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
// import Button from '@material-ui/core/Button';
// import Avatar from '@material-ui/core/Avatar';
// import List from '@material-ui/core/List';
// import ListItem from '@material-ui/core/ListItem';
// import ListItemAvatar from '@material-ui/core/ListItemAvatar';
// import ListItemText from '@material-ui/core/ListItemText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
// import PersonIcon from '@material-ui/icons/Person';
// import AddIcon from '@material-ui/icons/Add';
import Typography from '@material-ui/core/Typography';
import blue from '@material-ui/core/colors/blue';
import ShareIcon from '@material-ui/icons/Share';
import { FacebookShareButton, LinkedinShareButton, TwitterShareButton} from 'react-share';
import IconButton from '@material-ui/core/IconButton';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import CloseIcon from '@material-ui/icons/Close';
import Fab from '@material-ui/core/Fab';
import Grid from '@material-ui/core/Grid';

const styles = {
  avatar: {
    backgroundColor: blue[100],
    color: blue[600],
  },
  dialogPaper: {
    backgroundColor: '#282828'
  },
  iconWrapper :{
    padding: '0px 14px 20px'
  },
  socialName: {
    paddingTop: 10,
    color: '#fff'
  },
  socialIcon: {
    color: '#fff',
    fontSize: 25
  },
  facebookBtn: {
    backgroundColor: '#014ca9'
  },
  twitterBtn: {
    backgroundColor: '#00aff2',
  },
  linkdinBtn: {
    backgroundColor: '#006cc6',
  },
  dialogTitle: {
    color: '#fff',
    backgroundColor: 'red'
  }
};

class ShareDialog extends React.Component {
  handleClose = () => {
    this.props.onClose(this.props.selectedValue);
  };

  handleListItemClick = value => {
    this.props.onClose(value);
  };

  render() {
    const { classes, onClose, selectedValue, asPath, title, ...other } = this.props;
    return (
      <Dialog onClose={this.handleClose} aria-labelledby="dialog-title" {...other} classes={{ paper: classes.dialogPaper }} >
     <Grid
      container
      direction="row"
      justify="space-between"
      alignItems="center"
    >
        <DialogTitle disableTypography id="dialog-title"> 
          <Typography component='h2' style={{ color: '#fff', fontSize: 20 }} >
            Share With
          </Typography>
        </DialogTitle>
        <IconButton color="inherit" onClick={this.handleClose} aria-label="Close" style={{ color: '#fff' }} >
            <CloseIcon />
        </IconButton>
      </Grid>

      <Grid container
        direction="row" style={{ padding: '0px 20px 10px' }}>
        <Grid item xs={4} sm={4} md={4} className={classes.iconWrapper}>
          <FacebookShareButton
                  url={`${process.env.BACKEND_URL}${asPath}`}
                >  
                  <Fab aria-label="Share" className={classes.facebookBtn}>
                    <FontAwesomeIcon icon={['fab', 'facebook-f']}className={classes.socialIcon}/>
                  </Fab>
                  <Typography component='p' className={classes.socialName}>
                    Facebook
                  </Typography>
                </FacebookShareButton>

          </Grid>
        <Grid item xs={4} sm={4} md={4} className={classes.iconWrapper}>
          <LinkedinShareButton
                  url={`${process.env.BACKEND_URL}${asPath}`}
                  quote={title}
                >  
                  <Fab aria-label="Share" className={classes.twitterBtn}>
                    <FontAwesomeIcon  icon={['fab', 'twitter']} className={classes.socialIcon}/>
                  </Fab>
                  <Typography component='p' className={classes.socialName}>
                    Twitter
                  </Typography>
                </LinkedinShareButton>

          </Grid>
          <Grid item xs={4} sm={4} md={4} className={classes.iconWrapper}>
          <TwitterShareButton
                  url={`${process.env.BACKEND_URL}${asPath}`}
                  quote={title}
                >  
                  <Fab aria-label="Share" className={classes.linkdinBtn}>
                    <FontAwesomeIcon icon={['fab', 'linkedin-in']} className={classes.socialIcon}/>
                  </Fab>
                  <Typography component='p' className={classes.socialName}>
                    Linkdin
                  </Typography>
                </TwitterShareButton>

          </Grid>
        </Grid>
     
      </Dialog>
    );
  }
}

ShareDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  onClose: PropTypes.func,
  selectedValue: PropTypes.string,
};

const ShareDialogWrapped = withStyles(styles)(ShareDialog);

class VideoDetailShareBtn extends React.Component {
  state = {
    open: false,
  };

  handleClickOpen = () => {
    this.setState({
      open: true,
    });
  };

  handleClose = value => {
    this.setState({ selectedValue: value, open: false });
  };

  render() {
    const { customProps, asPath, title } = this.props;
    return (
      <div>
        <Fab color="primary" aria-label="Share" onClick={this.handleClickOpen} {...customProps}>
            <ShareIcon />
        </Fab>
        <ShareDialogWrapped
          asPath={asPath}
          title={title}
          selectedValue={this.state.selectedValue}
          open={this.state.open}
          onClose={this.handleClose}
        />
      </div>
    );
  }
}

export default VideoDetailShareBtn;
